<template>
    <layouts-header></layouts-header>

    <cage-breadcrumb :title="title" :text="text" :text1="text1" />

    <coach-tabset></coach-tabset>

    <!-- Page Content -->
    <div class="content">
        <div class="container">
            <section class="mb-40">
                <div class="text-center mb-40">
                    <h3 class="mb-1">Personal Information</h3>
                    <p class="sub-title">Ensure accurate and complete information for a smooth booking process.</p>
                </div>
                <div class="card">
                    <h3 class="border-bottom">Enter Details</h3>
                    <form>
                        <div class="mb-3">
                            <label for="name" class="form-label">Name</label>
                            <input type="text" class="form-control" id="name" placeholder="Enter Name">
                        </div>
                        <div class="mb-3">
                            <label for="email" class="form-label">Email</label>
                            <input type="email" class="form-control" id="email" placeholder="Enter Email Address">
                        </div>
                        <div class="mb-3">
                            <label for="name" class="form-label">Phone Number</label>
                            <input type="text" class="form-control" id="phonenumber" placeholder="Enter Phone Number">
                        </div>
                        <div class="mb-3">
                            <label for="name" class="form-label">Your Address</label>
                            <input type="text" class="form-control" id="address" placeholder="Enter Address">
                        </div>
                        <div>
                            <label for="comments" class="form-label">Details</label>
                            <textarea class="form-control" id="comments" rows="3" placeholder="Enter Comments"></textarea>
                        </div>
                    </form>
                </div>
            </section>
            <div class="text-center btn-row">
                <router-link class="btn btn-primary me-3 btn-icon" to="/coaches/coach-timedate"><i
                        class="feather-arrow-left-circle me-1"></i> Back</router-link>
                <router-link class="btn btn-secondary btn-icon" to="/coaches/coach-order-confirm">Next <i
                        class="feather-arrow-right-circle ms-1"></i></router-link>
            </div>
        </div>
        <!-- /Container -->
    </div>
    <!-- /Page Content -->

    <layout-footer></layout-footer>
</template>

<script>
export default {
    data() {
        return {
            title: 'Book A Coach',
            text: 'Home',
            text1: 'Book A Coach',
        }
    },
}
</script>